import { Button, DatePicker, Form, Select, Tabs,Input,message } from 'antd';
import axios from "axios";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getReceivedSkidBarcodes, getUsers } from '../../../../actions/index';
import { BASE_URL, HEADER_OPTIONS_AUTH } from "../../../lib/basic";
import ReactTable from 'react-table';
import { CSVLink, CSVDownload } from "react-csv";

import { openNotificationWithIcon } from '../../../lib/utils';
import EyeButton from './EyeButton';

let dateFormat = require('dateformat');
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

export const ReportUI = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(state => state.authenticated);
  const barCodes = useSelector(state => state.receivedSkidsBarcodes);
  const allusers = useSelector(state => state.users);
  const [companies, setcompanies] = useState([]);
  const [loading, setloading] = useState(false);
  const [reportsData,setReportsData]=useState(null)
  const [skidBarcodes,setSkidBarcodes]=useState("")
  const [isGenerating,setIsGenerating]=useState(false)
  let [unavailableSkids,setUnavailableSKids]=useState(null)

  const info = () => {
    message.info('REPORT in progress. Do not exit from program');
  };

  useEffect(() => {
    if (!user) {
      history.push('/');
    } else {
      getUsers(user, dispatch);
      getReceivedSkidBarcodes(user, dispatch);
    }
  }, []);

  useEffect(() => {
    if (allusers) {
      setcompanies(allusers.filter(
        user => user.companyName !== "LACERO" && user.role === "client"
      ));
    }
  }, [allusers])



  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 8,
    },
  };
  const tailLayout = {
    wrapperCol: {
      offset: 10,
      span: 12,
    },
  };
  const rangeConfig = {
    rules: [{ type: 'array', required: true, message: 'Please select time!' }],
  };

  const onNextProcessReport = async (values) => {

    try {
      let endDate = moment(values.date[1]).add(1, 'days').format('YYYY-MM-DD');

      const data = {
        'companyID': values.companyID,
        'startDate': values.date[0].format('YYYY-MM-DD'),
        'endDate': dateFormat(endDate, "yyyy-mm-dd"),
      };

      const options = HEADER_OPTIONS_AUTH(user.token);
      //send request to get a blob xlsx report
      info();
      setloading(true);
     
      options.responseType = 'blob';

      await axios.post(`${BASE_URL}/download-processed-item-report`, data, options)
        .then(function (response) {
            // setReportsData(response.data.data)

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `processed_report_${data.startDate}_to_${data.endDate}.xlsx`);
          document.body.appendChild(link);
          link.click();
          openNotificationWithIcon('success', `Download Report Success`);
          setloading(false);
        })
        .catch(function (error) {
          setloading(false);
          if (error.response) {
            // Request made and server responded
            openNotificationWithIcon(
              "error",
              error.response.statusText
            );
          } else if (error.request) {
            // The request was made but no response was received
            openNotificationWithIcon(
              "error",
              "No internet!"
            );
          } else {
            // Something happened in setting up the request that triggered an Error
            openNotificationWithIcon(
              "error",
              error.message
            );
          }
        });

    } catch (e) {
      console.log(e);
      setloading(false);
      openNotificationWithIcon('error', `Download Report Failed`)
    }

  }

  const onNextDownloadMultipleSkidsReport = async (values) => {
    // console.log(values.skidBarcodes);
    try {
      setIsGenerating(true)
      let enteredSkidsArray=skidBarcodes?.split(' ')
      let correctSkidsArray=[]
      let validSkidsArray=[]
      let inValidSkidsArray=[]
     let  unavailableSkidsFromBackend=[]
     let unavailableSkidsArray=[]
     let totalUnavailableSkids=[]

      enteredSkidsArray.forEach(skid=>{
        if(skid.includes("\n"))
        {
        let correctSkid=skid.replace(/\n/g,'')
        correctSkidsArray.push(correctSkid)
        }
        else{
          correctSkidsArray.push(skid)
        }
    
       
      })
      console.log('Entered Skids',enteredSkidsArray);
      console.log('Correct Skids',correctSkidsArray)
      const regex =/^(HOND|GM)\d{0,20}$/;
      correctSkidsArray.forEach(skid=>{
        if(regex.test(skid))
        {
          validSkidsArray.push(skid)
        }
        else{
          if(skid.length>0){
          let invalidSkid={
            skid:skid,
            reason:"Invalid Skid format, please recheck"
          }
          inValidSkidsArray.push(invalidSkid)
        }
       
      }
      })
      console.log('Valid Skids',validSkidsArray)
      console.log('Invalid Skids',inValidSkidsArray)
      const correctSkidBarcodes = validSkidsArray.reduce((accumulator, currentSkid) => accumulator + currentSkid+" ", "");
      console.log('correctskidBarcodes',correctSkidBarcodes)
      // const skidBarCodes = values.skidBarcodes;
      const data = {
        'barCodes': correctSkidBarcodes
      };
      info();
      setloading(true);
      const options = HEADER_OPTIONS_AUTH(user.token);
     
      //send request to get a blob xlsx report
      await axios.post(`${BASE_URL}/skidbarCodeAvailability`, data, options)
        .then(function (response) {
          unavailableSkidsFromBackend=response?.data?.unavailableSkid
          if(unavailableSkidsFromBackend?.length>0)
          {
            for(let skid of unavailableSkidsFromBackend)
            {
              if(skid.length>0){
              let skidObj={
                skid:skid,
                reason:'Skid Data Not Available in Database'
              }
              unavailableSkidsArray.push(skidObj)
            }
            }
          }
         console.log('response',response.data)
        })
        .catch(function (error) {
          
          if (error.response) {
            // Request made and server responded
            openNotificationWithIcon(
              "error",
              error.response.data.message
            );
          } else if (error.request) {
            // The request was made but no response was received
            openNotificationWithIcon(
              "error",
              "No internet!"
            );
          } else {
            // Something happened in setting up the request that triggered an Error
            openNotificationWithIcon(
              "error",
              error.message
            );
          }
        })
        options.responseType = 'blob';
      await axios.post(`${BASE_URL}/download-processed-item-report-multiple-skid`, data, options)
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Multiple_skids_Report_${moment().format("DD-MM-YYYY")}.xlsx`);
          document.body.appendChild(link);
          link.click();
          openNotificationWithIcon('success', `Download Report Success`);
          setloading(false);
        })
        .catch(function (error) {
          setloading(false);
          if (error.response) {
            // Request made and server responded
            openNotificationWithIcon(
              "error",
              error.response.data.message
            );
          } else if (error.request) {
            // The request was made but no response was received
            openNotificationWithIcon(
              "error",
              "No internet!"
            );
          } else {
            // Something happened in setting up the request that triggered an Error
            openNotificationWithIcon(
              "error",
              error.message
            );
          }
        });
        totalUnavailableSkids=inValidSkidsArray?.concat(unavailableSkidsArray)
        console.log('total Unavailable Skids',totalUnavailableSkids)
        setUnavailableSKids(totalUnavailableSkids)
setIsGenerating(false)
    } catch (e) {
      console.log(e);
      setloading(false);
      openNotificationWithIcon('error', `Download Report Failed`)
      setIsGenerating(false)

    }

  }

  const columns=[
    {id:'skid',
    header:'Skid Barcode',
    accessor:'skid',
    title:'skid',
    dataIndex:'skid'
    },
    {
      id:'reason',
      header:'Reason',
      accessor:'reason',
      title:'reason',
      dataIndex:'reason'
    }
  ]

  const onNextSkidReport = async (values) => {
    console.log(values.skidBarcode);
    try {
      const skidBarCode = values.skidBarcode;
      const data = {
        'skidBarcode': values.skidBarcode
      };

      const options = HEADER_OPTIONS_AUTH(user.token);
      options.responseType = 'blob';
      //send request to get a blob xlsx report
      info();
      setloading(true);

      await axios.post(`${BASE_URL}/download-processed-item-report-skid`, data, options)
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `processed_report_${skidBarCode}.xlsx`);
          document.body.appendChild(link);
          link.click();
          openNotificationWithIcon('success', `Download Report Success`);
          setloading(false);
        })
        .catch(function (error) {
          setloading(false);
          if (error.response) {
            // Request made and server responded
            openNotificationWithIcon(
              "error",
              error.response.data.message
            );
          } else if (error.request) {
            // The request was made but no response was received
            openNotificationWithIcon(
              "error",
              "No internet!"
            );
          } else {
            // Something happened in setting up the request that triggered an Error
            openNotificationWithIcon(
              "error",
              error.message
            );
          }
        });

    } catch (e) {
      console.log(e);
      setloading(false);
      openNotificationWithIcon('error', `Download Report Failed`)
    }

  }

  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Process Report" key="1">
          <Form
            {...layout}
            name="process-report"
            onFinish={onNextProcessReport}
          >
            <Form.Item name="companyID" label="Company" rules={[{ required: true, message: "Please select company!" }]}>
              <Select
                placeholder="Select a company"
                allowClear
              >
                {companies.map((company, index) => {

                  return (
                    <Option value={company.companyID} key={index}>{company.companyName}</Option>
                  )
                })}
              </Select>
            </Form.Item>

            <Form.Item name="date" label="Date" {...rangeConfig}>
              <RangePicker />
            </Form.Item>


            <Form.Item {...tailLayout}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Submit
                    </Button>
            </Form.Item>
            {/* {reportsData && reportsData.length>0?
<div>
<CSVLink style={{display:'flex',padding:'10px',textAlign:'center',justifyContent:'center',color:'whitesmoke',background:'#4a7ca8',borderRadius:'5px',fontSize:'18px',fontWeight:'bold'}} data={reportsData} filename={`Process_Report`}>Download ↓</CSVLink>
</div>:null} */}
          </Form>
        </TabPane>




        {/* skid report */}
        <TabPane tab="Individual Skid Report" key="2">
          <Form
            {...layout}
            name="skid-report"
            onFinish={onNextSkidReport}
          >
            <Form.Item name="skidBarcode" label="Skid" rules={[{ required: true, message: "Please Enter skid Barcode" }]}>
              <Select
                showSearch
                style={{ width: 350 }}
                placeholder="Search a Skid"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return option.props.children.toUpperCase().indexOf(input.toUpperCase()) >= 0
                }

                }
              >
                {barCodes && barCodes.map((skid, index) => <Option value={skid.barCode} key={index}>{skid.barCode}</Option>)}
              </Select>
            </Form.Item>



            <Form.Item {...tailLayout}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Submit
                    </Button>
            </Form.Item>
          </Form>
        </TabPane>
        <TabPane tab="Multiple Skids Report" key="3">
          <Form
            {...layout}
            name="multiple-skid-report"
            onFinish={onNextDownloadMultipleSkidsReport}
          >
            <Form.Item name="skidBarcodes" label="Skids">
            <TextArea value={skidBarcodes} onChange={(e)=>{setSkidBarcodes(e.target.value)}} id="enteredVins"  autoSize={{ minRows: 2, maxRows: 6 }} placeholder="Please Enter skid Barcodes seperated by spaces only" /> 
                  {/* <EyeButton  message="Please Enter skid Barcodes seperated by spaces only"/> */}
            </Form.Item>
                

            {!isGenerating?
            <Form.Item {...tailLayout}>
              <Button type="primary" htmlType="submit" loading={loading}>
                Submit
                    </Button>

            </Form.Item>:
                    <div style={{display:'flex',width:'100%',marginLeft:'-20px', justifyContent:'center',alignItems:'center',textAlign:'center',padding:'5px',fontSize:'20px',fontWeight:'bold',color:'#50923b'}}>
                      Report Generation in progress. Do not exit from program..
                    </div>
}
          </Form>
          {/* {unavailableSkids?.length>0?
          <ReactTable
                    data={unavailableSkids}
                    columns={columns}
                />:null
          } */}
          {unavailableSkids?.length>0?
          <div style={{display:'flex',width:'100%',flexDirection:'column'}} >
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',width:'100%',fontWeight:'bold',padding:'10px',fontSize:'28px'}}>
              Unavailable Skids
            </div>
          <div style={{display:'flex',justifyContent:'center',alignItems:'center',textAlign:'center',width:'100%'}}>
  
              <table style={{width: '50%', border: '1px solid lightgray', borderCollapse: 'collapse'}}>
        <tr>
        
            <th style={{border:'1px solid lightgray' ,padding: '8px', textAlign: 'left'}}>Skid Id</th>
            <th style={{border:'1px solid lightgray' ,padding: '8px', textAlign: 'left'}}>Reason</th>
            
        </tr>
        <tbody>
          {unavailableSkids?.map((skid,id)=>{
            return(
              <tr key={id}>
              <td style={{border:'1px solid lightgray' ,padding: '8px', textAlign: 'left'}}>{skid.skid}</td>
              <td style={{border:'1px solid lightgray' ,padding: '8px', textAlign: 'left'}}>{skid.reason}</td>
          </tr>
            )
          })
      
}
        </tbody>
    </table>

          </div>
          </div>:null

          }
        </TabPane>
      </Tabs>
    </div>

  );

}
